import { createSaga } from './saga-helpers';

import * as Api from '../api/users-api';

const watchGetUsers = createSaga({
    type: 'USERS_FETCH',
    fn: Api.fetchUsers,
    args: action => [action.payload],
    successPayload: ({ items, hasMore } = {}, action) => ({
        users: items,
        hasMore,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchGetUser = createSaga({
    type: 'USER_FETCH',
    fn: Api.fetchUser,
    args: action => [action.payload.userId],
    successPayload: (user, action) => ({
        user,
        userId: action.payload.userId
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchGetCurrentUser = createSaga({
    type: 'CURRENT_USER_FETCH',
    fn: Api.fetchCurrentUser,
    args: action => [action.payload.masterUser],
    successPayload: user => ({ user })
});

const watchGetSubscriptions = createSaga({
    type: 'SUBSCRIPTIONS_FETCH',
    fn: Api.fetchSubscriptions,
    args: action => [],
    successPayload: subscriptions => ({ subscriptions })
});

const watchUpdateCurrentUser = createSaga({
    type: 'CURRENT_USER_UPDATE',
    fn: Api.updateCurrentUser,
    args: action => [action.payload.userProps],
    successPayload: user => ({ user })
});

const watchUpdateCurrentUserPassword = createSaga({
    type: 'CURRENT_USER_UPDATE_PASSWORD',
    fn: Api.updateCurrentUserPassword,
    args: action => [action.payload.userProps],
    successPayload: user => ({ user })
});

const watchUpdateCurrentUserEmail = createSaga({
    type: 'CURRENT_USER_UPDATE_EMAIL',
    fn: Api.updateCurrentUserEmail,
    args: action => [action.payload.userProps],
    successPayload: user => ({ user })
});

const watchLinkSSOUser = createSaga({
    type: 'USER_SSO_LINK',
    fn: Api.linkSSO,
    args: action => [action.payload.provider, action.payload.socialData],
    successPayload: token => ({ token })
});

const watchUnlinkSSOUser = createSaga({
    type: 'USER_SSO_UNLINK',
    fn: Api.unlinkSSO,
    args: action => [action.payload.provider],
    successPayload: token => ({ token })
});

const watchSetNotificationSetting = createSaga({
    type: 'NOTIFICATION_SETTING_SET',
    fn: Api.setNotificationSetting,
    args: action => [action.payload.notificationSetting],
    successPayload: settings => ({ settings })
});

const watchRemoveNotificationSetting = createSaga({
    type: 'NOTIFICATION_SETTING_REMOVE',
    fn: Api.removeNotificationSetting,
    args: action => [action.payload.notificationSetting],
    successPayload: settings => ({ settings })
});

const watchUpdateUser = createSaga({
    type: 'USER_UPDATE',
    fn: Api.updateUser,
    args: action => [action.payload.userId, action.payload.userProps]
});

const watchUpdateInviteResend = createSaga({
    type: 'USER_INVITE_RESEND',
    fn: Api.resendInvite,
    args: action => [action.payload.userId, action.payload.projectId]
});

const watchAddUserLabels = createSaga({
    type: 'USER_LABELS_ADD',
    fn: Api.addUserLabels,
    args: action => [action.payload.userId, action.payload.labels]
});

const watchRemoveUserLabels = createSaga({
    type: 'USER_LABELS_REMOVE',
    fn: Api.removeUserLabels,
    args: action => [action.payload.userId, action.payload.labels]
});

const watchRemoveUser = createSaga({
    type: 'USER_REMOVE',
    fn: Api.removeUser,
    args: action => [action.payload.userId, action.payload.projectId, action.payload.projectsOnly]
});

const sagas = [watchGetUsers, watchGetUser, watchGetCurrentUser, watchGetSubscriptions, watchUpdateCurrentUser, watchUpdateCurrentUserPassword, watchUpdateCurrentUserEmail, watchLinkSSOUser, watchUnlinkSSOUser, watchSetNotificationSetting, watchRemoveNotificationSetting, watchUpdateUser, watchUpdateInviteResend, watchAddUserLabels, watchRemoveUserLabels, watchRemoveUser];

export default sagas;
